import React from 'react';
import * as Sentry from '@sentry/react';

import SearchErrorMessage from '../ErrorMessage';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Catches render errors in search components, so a broken search shows an
 * error message instead of taking down the whole page. Retrying remounts the
 * search, which sends a new request.
 */
class SearchErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <SearchErrorMessage onRetry={() => this.setState({ hasError: false })} />;
    }

    return children;
  }
}

export default SearchErrorBoundary;
